module.exports = __webpack_public_path__ + "img/A928.1023b1a6.jpg";